var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex game-container"},[(_vm.url)?_c('iframe',{staticClass:"w-100 h-100",staticStyle:{"flex":"1","border":"none"},attrs:{"src":_vm.url}}):_c('span',[_vm._v(" "+_vm._s(_vm.$t("Game not found"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }